export enum ConnectorModalType {
  NONE = 'NONE',
}

export enum ConnectorErrorType {
  GENERIC_ERROR = 'GENERIC_ERROR',
  CONFIGURATION_ERROR = 'CONFIGURATION_ERROR',
  NONE = 'NONE',
}

export interface ConnectorModalPayload {
  type: ConnectorModalType
  confirmCallback?: () => void
  cancelCallback?: () => void
}
